export const SMS_TEXT = 'https://play.google.com/store/apps/details?id=com.app.icause';

export const SMS_COUNTRY_CODES = [
  { code: '+61', country: 'AUS' }
];

export const MEMBER_TYPES = [
  'school',
  'sport',
  'community',
  'charity'
];

export const COUNTRY="Australia";
export const COUNTRY2="Pakistan";

export const COMPANY_TYPES = [
  { name: 'school', title: 'School', pluralName: 'Schools' },
  { name: 'community', title: 'Community', pluralName: 'Communities' },
  { name: 'sport', title: 'Sport', pluralName: 'Sports' },
  { name: 'charity', title: 'Charity', pluralName: 'Charities' },
];

export const imageURL = process.env.REACT_APP_IMAGES_URL;
export const imageURLS3 = process.env.REACT_APP_IMAGES_URL_S3;